import { MaskLines, Eyebrow } from "./Reveal";

export const PageHead = ({ eyebrow, lines, children }) => (
  <section className="mx-auto max-w-[1440px] px-5 pb-12 pt-[136px] md:px-10 md:pb-16 md:pt-[180px]">
    <Eyebrow>{eyebrow}</Eyebrow>
    <h1 data-testid="page-title" className="font-wide mt-6 text-4xl font-black uppercase leading-[0.88] tracking-[-0.02em] sm:text-6xl lg:text-8xl">
      <MaskLines lines={lines} delay={0.1} />
    </h1>
    {children}
  </section>
);
